import '.b2{position:relative;}.ssr-plugin'
import '.jf{width:64px;}.ssr-plugin'
import '.jg{height:64px;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.c2{position:absolute;}.ssr-plugin'
import '.jh{bottom:-4px;}.ssr-plugin'
import '.i8{right:-4px;}.ssr-plugin'
import '.fz{border-radius:50%;}.ssr-plugin'
import '.d7{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bd{overflow:hidden;}.ssr-plugin'
import '.ji{width:32px;}.ssr-plugin'
import '.jj{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="b2 jf jg ag"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="c2 jh i8 fz d7 bd ji jj"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
